import React, { Component } from 'react';
import { connect } from "react-redux";

import axios from "axios";
import ReactTooltip from 'react-tooltip'

import Stars from '../../../Common/Stars';
import { DivisionIcon, VCIcon } from '../../../Common/Buttons/TypeIcons';

//Vehicle Cell is 
class VehicleCellTooltip extends Component {
    constructor(props) {
        super(props);

        this.imageError = this.imageError.bind(this);
        this.forceShowOverlay = this.forceShowOverlay.bind(this);

        this.state = {
        };
    }

    imageError(e) {
        e.target.src = this.props.settings.images.vehicle_placeholder_square.includes("images/") ? this.props.settings.images.vehicle_placeholder_square : "images/" + this.props.settings.images.vehicle_placeholder_square
    }

    forceShowOverlay() {
        var base_url = (this.props.match.url).split('/')[1]
        this.props.history.push("/" + base_url + '/vehicle/' + this.props.vehicle.V_ID + '/Overview')
    }


    render(props) {
        if (this.props.x && this.props.y) {
            return (
                <div className="vehicle_cell_tooltip_container" style={{left: this.props.x, top: this.props.y}}>
                    <div className="vehicle_cell_tooltip">
                        <div className="vehicle_cell_tooltip_info">
                            <div className="vehicle_tooltip_thumbnail">
                                {
                                    this.props.vehicle.Photos != '' ?
                                        <img onError={this.imageError} src={'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_' + this.props.vehicle.Photos} />
                                    :
                                        <img src={this.props.settings.images.vehicle_placeholder_square.includes("images/") ? this.props.settings.images.vehicle_placeholder_square : "images/" + this.props.settings.images.vehicle_placeholder_square} style={{width:'100%'}}/>
                                    }
                            </div>
                                <div className="vehicle_cell_tooltip_info_info_title_area">
                                <div className="vehicle_cell_tooltip_info_info_title">
                                    <span className="vehicle_cell_tooltip_info_title_text">{this.props.vehicle.Year} {this.props.vehicle.Make} {this.props.vehicle.Model} {this.props.vehicle.Trim}</span>
                                        <Stars star={this.props.data.vehicle_db[this.props.vehicle.V_ID]?.tier[0].Rank} type={"Vehicle"}/> 
                                </div>
                                <div className="vehicle_cell_tooltip_info_subtitle">
                                    <span className="vehicle_cell_tooltip_vin">{this.props.vehicle.VIN}</span>
                                    <span className="vehicle_cell_tooltip_odometre">{new Intl.NumberFormat('en-CA').format(this.props.vehicle.Odometer)} KM</span>
                                </div>
                            </div>
                        </div>
                        <div className="vehicle_cell_tooltip_type">
                            <div className="vehicle_cell_tooltip_type_icon">{VCIcon(this.props.vehicle.vmh, null, null, null, true)}{this.props.vehicle.vmh.Display_Name+" - "+this.props.vehicle.vmh.Display_City}</div>
                            <div className="vehicle_cell_tooltip_type_icon">{DivisionIcon(this.props.vehicle.stakeholder, null, null, null, true)}{this.props.vehicle.stakeholder.Division} Division</div>
                        </div>
                    </div>
                    <a className = "link float-right medium mt-12" style={{cursor:"pointer"}} onClick={this.forceShowOverlay}>See Details<i className="fas fa-arrow-right ml-12"></i></a>
                </div>
            );
        }
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    settings: store.settings
})

export default connect(mapStateToProps)(VehicleCellTooltip)